import { MarkerClusterer } from "@googlemaps/markerclusterer";

export let myPolygon;

export default class CustomMarkerClusterer extends MarkerClusterer {
    constructor({ map, markers = [], algorithmOptions = {}, algorithm, renderer, onClusterClick }) {
        super({
            map,
            markers,
            algorithmOptions,
            algorithm,
            renderer,
            onClusterClick,
        });
    }

    renderData() {
        this.render();
    }

    async renderClusters() {
        // generate stats to pass to renderers
        super.renderClusters();
        const map = this.getMap();
        for (let cluster of this.clusters) {
            if (cluster.markers.length > 1) {
                cluster.marker.addListener("mouseover", (event) => {
                    drawPoly(event, cluster);
                });
                cluster.marker.addListener("mouseout", (event) => {
                    myPolygon?.setMap(null);
                });
            }
        }

        const drawPoly = (event, cluster) => {
            myPolygon?.setMap(null);
            let triangleCoords = [];
            let centerPt;
            var bounds = new window.google.maps.LatLngBounds();

            function sortFunc(a, b) {
                var bearA = window.google.maps.geometry.spherical.computeHeading(centerPt, a);
                var bearB = window.google.maps.geometry.spherical.computeHeading(centerPt, b);
                return bearA - bearB;
            }
            for (let marker of cluster.markers) {
                var temp = marker.position;
                triangleCoords.push(temp);
                bounds.extend(temp);
            }
            centerPt = bounds.getCenter();

            triangleCoords = triangleCoords.sort(sortFunc);
            let positiveLess90 = [];
            var positiveLess90Bounds = new window.google.maps.LatLngBounds();
            let positiveGreater90 = [];
            var positiveGreater90Bounds = new window.google.maps.LatLngBounds();
            let negativeLess90 = [];
            var negativeLess90Bounds = new window.google.maps.LatLngBounds();
            let negativeGreater90 = [];
            var negativeGreater90Bounds = new window.google.maps.LatLngBounds();

            positiveLess90Bounds.extend(centerPt);
            positiveGreater90Bounds.extend(centerPt);
            negativeLess90Bounds.extend(centerPt);
            negativeGreater90Bounds.extend(centerPt);
            for (let cords of triangleCoords) {
                let dd = window.google.maps.geometry.spherical.computeHeading(centerPt, cords);
                if (window.google.maps.geometry.spherical.computeHeading(centerPt, cords) > 0) {
                    if (dd < 90) {
                        positiveLess90.push(cords);
                        positiveLess90Bounds.extend(cords);
                    } else {
                        positiveGreater90.push(cords);
                        positiveGreater90Bounds.extend(cords);
                    }
                } else {
                    if (dd > -90) {
                        negativeLess90.push(cords);
                        negativeLess90Bounds.extend(cords);
                    } else {
                        negativeGreater90.push(cords);
                        negativeGreater90Bounds.extend(cords);
                    }
                }
            }

            let positiveLess90ll = getPolyCoords(centerPt, positiveLess90, positiveLess90);
            let positiveGreater90ll = getPolyCoords(centerPt, positiveGreater90, positiveGreater90);
            let negativeLess90ll = getPolyCoords(centerPt, negativeLess90, negativeLess90);
            let negativeGreater90ll = getPolyCoords(centerPt, negativeGreater90, negativeGreater90);

            let ll = [...negativeGreater90ll, ...negativeLess90ll, ...positiveLess90ll, ...positiveGreater90ll];

            //ll = getPolyCoords(centerPt, ll, ll)

            let ffd = [];
            if (ll.length > 6 && ll.length < 100) {
                let min = 200000000;
                let max = 0;
                for (let ff of ll) {
                    const distance = window.google.maps.geometry.spherical.computeDistanceBetween(ff, centerPt);
                    if (distance < min) {
                        min = distance;
                    }

                    if (distance > max) {
                        max = distance;
                    }
                }

                for (let ff of ll) {
                    const distance = window.google.maps.geometry.spherical.computeDistanceBetween(ff, centerPt);

                    if (distance <= min + 300) {
                        console.log("Coordinate is within the circle");
                    } else {
                        ffd.push(ff);
                    }
                }
            } else {
                ffd = ll;
            }

            myPolygon = new window.google.maps.Polygon({
                paths: ffd,
                strokeColor: "#00afff",
                strokeOpacity: 0.8,
                strokeWeight: 3,
                fillColor: "transparent",
                fillOpacity: 0.0,
            });

            myPolygon.setMap(map);
        };

        const getPolyCoords = (center, coordinated, prevCoords) => {
            let ll = [];
            if (coordinated.length > 7) {
                let min = 200000000;
                let max = 0;
                for (let ff of coordinated) {
                    const distance = window.google.maps.geometry.spherical.computeDistanceBetween(ff, center);
                    if (distance < min) {
                        min = distance;
                    }

                    if (distance > max) {
                        max = distance;
                    }
                }

                for (let ff of coordinated) {
                    const distance = window.google.maps.geometry.spherical.computeDistanceBetween(ff, center);

                    if (distance <= min + (max - min) / 2) {
                        console.log("Coordinate is within the circle");
                    } else {
                        ll.push(ff);
                    }
                }
            } else {
                ll = coordinated;
            }

            if (ll.length > 7) {
                ll = getPolyCoords(center, ll, coordinated);
            } else if (ll.length < 3) {
                ll = coordinated;
            }

            return ll;
        };
    }
}
